import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Input, notification, Checkbox, Icon, Drawer, Tooltip, Row, Col, Select } from "antd";
import axios from "axios";

import { noimage } from "../../../../assets";

import { arraysHaveSameElements } from "../../../../shared/utils/compare";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};
const DrawerCarrosel = ({ ativo, visible, id, form, onClose, atualizar }) => {
    const [todos, setTodos] = useState(false);
    const [formData, setFormData] = useState({
        capa: "",
        preview: "",
        selecionados: [],
        previews: [null, null, null],
        files: [null, null, null]
    });
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [validate, setValidate] = useState({
        totalBytes: 0,
        formatoValido: false,
        validateStatus: "",
        help: ""
    });
    const [loading, setLoading] = useState(false);
    const { getFieldDecorator } = form;
    const { TextArea } = Input;

    const tamanhoMaximo = 5 * (1024 * 1024);

    const guardar = () => {
        const file = formData.capa;
        const item = new FormData();
        item.append("file", file);
        item.append("estabelecimentos", JSON.stringify(formData.selecionados));

        form.validateFieldsAndScroll(async err => {
            if (!err && validate.totalBytes <= tamanhoMaximo && validate.formatoValido && formData.preview != "") {
                setLoading(true);

                axios({
                    method: "post",
                    url: "/api/carrocel/adicionar",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Imagem adicionada!");
                        setLoading(false);
                        atualizar();
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível adicionar imagem");
                        setLoading(false);
                    });
            } else {
                if (formData.preview == "")
                    setValidate({
                        totalBytes: 0,
                        formatoValido: false,
                        validateStatus: "error",
                        help: "Campo obrigatório"
                    });
            }
        });
    };

    const alterar = () => {
        form.validateFieldsAndScroll(err => {
            if (!err && validate.totalBytes <= tamanhoMaximo && validate.formatoValido && formData.preview !== "") {
                setLoading(true);
                const file = formData.capa;

                const item = new FormData();
                item.append("file", file);
                item.append("id", id);
                item.append("estabelecimentos", JSON.stringify(formData.selecionados));

                axios({
                    method: "put",
                    url: "/api/carrocel/atualizar",
                    data: item
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Imagem alterada!");
                        atualizar();
                        setLoading(false);
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível alterar imagem");
                        setLoading(false);
                    });
            } else {
                if (formData.preview == "")
                    setValidate({
                        totalBytes: 0,
                        formatoValido: false,
                        validateStatus: "error",
                        help: "Campo obrigatório"
                    });
            }
        });
    };

    const carregarDetalhe = () => {
        axios({
            method: "get",
            url: "/api/carrocel/detalhe",
            params: {
                id
            }
        })
            .then(response => {
                const sels = response.data.estabelecimentos.filter(estabelecimento => !!estabelecimento);

                setFormData({
                    capa: response.data.caminho,
                    preview: response.data.caminho,
                    selecionados: sels
                });

                if (response.data.caminho)
                    setValidate({
                        ...validate,
                        formatoValido: true
                    });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar informações");
            });
    };

    const listarEstabelecimentos = () => {
        axios({
            method: "get",
            url: "/api/gestao-organismos/listar-organismos"
        })
            .then(response => {
                setEstabelecimentos(response.data);
            })
            .catch(error => {});
    };

    const handleChangeCheckTodos = e => {
        const todos = e.target.checked;
        setTodos(todos);
        form.resetFields();

        if (todos) {
            const ids = estabelecimentos.map(x => x.id);
            setFormData({ ...formData, selecionados: ids });
        } else setFormData({ ...formData, selecionados: [] });
    };

    //UPLOAD DA FOTO/IMAGEM DO CURSO
    const uploadFoto = event => {
        if (event.target.files[0].size < tamanhoMaximo) {
            if (validarFormatoImagem(event.target.files[0].name.split(".").pop())) {
                setFormData({
                    ...formData,
                    capa: event.target.files[0],
                    preview: URL.createObjectURL(event.target.files[0])
                });
                setValidate({
                    totalBytes: event.target.files[0].size,
                    formatoValido: true,
                    validateStatus: "",
                    help: ""
                });
            } else {
                document.getElementById("input-foto").value = "";
                openNotificationWithIcon("error", "Erro", "Imagem com formato inválido");
            }
        } else {
            document.getElementById("input-foto").value = "";
            openNotificationWithIcon("error", "Erro", "Limite de 5 MB para a imagem.");
        }
    };

    //VALIDA O TIPO DE FICHEIRO COM OS FORMATOS ACEITES
    const validarFormatoImagem = formato => {
        var formatos = ["jpg", "jpeg", "png", "gif"];
        var valido = false;
        for (var i = 0; i < formatos.length; i++) {
            if (formato.toLowerCase() === formatos[i]) {
                valido = true;
                break;
            }
        }
        return valido;
    };

    //ABRE O FILE BROWSER
    const ativarUploadFoto = () => {
        document.getElementById("input-foto").click();
    };

    //REMOVE A FOTO
    const removerFoto = () => {
        document.getElementById("input-foto").value = "";
        setFormData({ ...formData, capa: "", preview: "" });
    };

    const afterVisibleChange = aberto => {
        if (aberto) {
            form.resetFields();
            document.getElementById("input-foto").value = "";
            if (id > 0) carregarDetalhe();
            else {
                setFormData({
                    capa: "",
                    preview: "",
                    selecionados: []
                });
                setValidate({
                    totalBytes: 0,
                    formatoValido: false,
                    validateStatus: "",
                    help: ""
                });
            }
        }
    };

    const validarTodosSelecionados = () => {
        const sels = formData.selecionados.filter(estabelecimento => !!estabelecimento);
        const ids = estabelecimentos.map(x => x.id);

        const sameElements = arraysHaveSameElements(ids, sels);

        setTodos(sameElements);
    };

    useEffect(() => {
        listarEstabelecimentos();
    }, []);

    useEffect(() => {
        validarTodosSelecionados();
    }, [formData.selecionados, todos]);

    return (
        <Drawer
            className="drawer-add-cursos drawer-videoconferencias"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal">
                    <div className="bloco-img">
                        <Form.Item validateStatus={validate.validateStatus} help={validate.help}>
                            <div>
                                <img
                                    style={{ width: "200px", height: "150px", objectFit: "cover" }}
                                    src={formData.preview ? formData.preview : noimage}
                                />
                            </div>
                            {ativo && (
                                <>
                                    {!formData.preview ? (
                                        <>
                                            <Link to="#" className="link-principal-border" onClick={ativarUploadFoto}>
                                                Adicionar
                                            </Link>{" "}
                                            <Tooltip
                                                className="info-icon"
                                                title={
                                                    <div>
                                                        <p>Tamanho máximo: 1MB</p>
                                                        {/*<p>Tamanho recomendado: 670x400px</p>*/}
                                                        <p>Formatos válidos: .gif, .jpg, .jpeg, .png</p>
                                                    </div>
                                                }
                                            >
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    ) : (
                                        <>
                                            <Link to="#" className="link-principal-border" onClick={ativarUploadFoto}>
                                                Alterar
                                            </Link>
                                            <Tooltip
                                                className="info-icon"
                                                title={
                                                    <div>
                                                        <p>Tamanho máximo: 1MB</p>
                                                        {/*<p>Tamanho recomendado: 670x400px</p>*/}
                                                        <p>Formatos válidos: .gif, .jpg, .jpeg, .png</p>
                                                    </div>
                                                }
                                            >
                                                <Icon type="question-circle-o" style={{ marginRight: 20 }} />
                                            </Tooltip>
                                            <Link to="#" className="link-principal-border" onClick={removerFoto}>
                                                Remover
                                            </Link>
                                        </>
                                    )}
                                </>
                            )}
                        </Form.Item>
                        <input type="file" id="input-foto" accept="image/*" onChange={uploadFoto} style={{ display: "none" }} />
                    </div>

                    <Form.Item label="Publicar em:">
                        <Checkbox checked={todos} onClick={handleChangeCheckTodos}>
                            Selecionar todos
                        </Checkbox>
                        {getFieldDecorator("selecionados", {
                            rules: [
                                {
                                    required: true,
                                    message: "Campo obrigatório"
                                }
                            ],
                            initialValue: formData.selecionados
                        })(
                            <Checkbox.Group
                                style={{ width: "100%" }}
                                disabled={!ativo}
                                onChange={selecionados => setFormData({ ...formData, selecionados })}
                            >
                                <Row>
                                    {estabelecimentos.map((estabelecimento, index) => (
                                        <Col key={estabelecimento.id} span={16}>
                                            <Checkbox value={estabelecimento.id} title={estabelecimento.nome}>
                                                {estabelecimento.abrev}
                                            </Checkbox>
                                        </Col>
                                    ))}
                                </Row>
                            </Checkbox.Group>
                        )}
                    </Form.Item>
                </Form>
            </div>
            <div className="ant-drawer-footer">
                <Link to="#" className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </Link>
                {ativo && (
                    <button className="botao-principal" disabled={loading} onClick={id > 0 ? alterar : guardar}>
                        {loading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                )}
            </div>
        </Drawer>
    );
};

const FormDrawerCarrosel = Form.create({ name: "form-drawer-carrossel" })(DrawerCarrosel);

export default FormDrawerCarrosel;
